/**
 * Ensure a given value is an array. If it is an array, it's returned unaltered.
 * If it's not an array, it's wrapped in an array and returned.
 * @param {value} value the value to check
 */
export const ensureArray = (value) => {
  if (value === null || value === undefined) {
    return [];
  }

  return Array.isArray(value) ? value : [value];
};

/**
 * Determine if a given array contains at least one item. Null or undefined returns false.
 * @param {value} value the array to check
 */
export const arrayHasItems = (value) => {
  if (!value) return false;

  const array = ensureArray(value);
  return array.length > 0;
};